module.exports = __webpack_public_path__ + "img/Butterfly_00190.43ace4b7.png";